/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagephasepast3Inputs */

const en_ticketpagephasepast3 = /** @type {(inputs: Ticketpagephasepast3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Over`)
};

const de_ticketpagephasepast3 = /** @type {(inputs: Ticketpagephasepast3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorbei`)
};

/**
* | output |
* | --- |
* | "Over" |
*
* @param {Ticketpagephasepast3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagephasepast3 = /** @type {((inputs?: Ticketpagephasepast3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagephasepast3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagephasepast3(inputs)
	return de_ticketpagephasepast3(inputs)
});
export { ticketpagephasepast3 as "ticketPagePhasePast" }